import { useRef, useState } from "react"
import { Allergen, batchNumber, buildBatchLabel, getAllergensForRecipe, getCombinedIngredients, recipeName, showQuantity } from "../specCardsHelpers"
import { add, format } from "date-fns"
import { cleanPID, fullRecipeType } from "../../../helpers/utils"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCheck, faClose } from "@fortawesome/free-solid-svg-icons"

export const Traceability = ({ selectedDate, recipe, recipes, allRecipes, multiplier, excludeSubs, setExcludeSubs, toggleCalModal }) => {

    const [bbe, setBBE] = useState('3.D')
    const [chilled, setChilled] = useState('CHILLED')
    const [initials, setInitials] = useState('')

    

    const bbeRef = useRef()
    const chilledRef = useRef()

    const changeBBE = () => {
      const val = bbeRef.current.value
      setBBE(val);
    }

    const changeChilled = () => {
      const val = chilledRef.current.value
      setChilled(val)
    }

    const changeName = (e) => {
      const val = e.target.value
      const arr = val.split(' ')

      const initials = arr.map(a => a[0]).join('')
      setInitials(initials.toUpperCase() || '')

    }

    const bbeOBJ = bbe.split('.')[1] === 'M' ? { months: parseInt(bbe.split('.')[0]) } : { days: parseInt(bbe.split('.')[0]) }

    const recipesToShowIngredientsFor = allRecipes.filter( r => !excludeSubs.includes(r.pid) )
 
    const ingredients = getCombinedIngredients(recipesToShowIngredientsFor)

    const childRecipes = recipe.ingredients.filter(r => r.recipe.type !== 'P')

    const allergens = getAllergensForRecipe(recipes, recipe)


    const BatchLabel = ({ selectedDate, recipe }) => {


    const [copied, setCopied] = useState(false)
    

    const batchHtml = buildBatchLabel(selectedDate, recipe, initials, bbeOBJ, allergens, true, chilled)
    const batchPlain = buildBatchLabel(selectedDate, recipe, initials, bbeOBJ, allergens, false, chilled)

    const copyToClipboard = async () => {
      const data = [
        new ClipboardItem({
          "text/html": new Blob([batchHtml], { type: "text/html" }),
          "text/plain": new Blob([batchPlain], { type: "text/plain" })
        })
      ];

      await navigator.clipboard.write(data);
      setCopied(true)
    }

    return (
      <div>
        <div className='batch-label' dangerouslySetInnerHTML={{ __html: batchHtml }}></div>
        <div className='center'><button className='inv' onClick={copyToClipboard}>{!copied ? 'Copy to clipboard' : 'Copied!'}</button><br/><br/><br/></div>
      </div>
    )
  }


    return <div className='traceabilityContainer'>

      <table>
        <tr>
          <td className='traceabilityHeader' colspan='2'><h2 style={{fontSize:26}}>{recipeName(recipe).toUpperCase()}</h2>Traceability Sheet - {fullRecipeType(recipe.type)} {cleanPID(recipe.pid, recipe.type)}</td>
        </tr>
        <tr>
          <td width='40%'>Date</td>
          <td><input className='editableDate' onClick={toggleCalModal} defaultValue={format(selectedDate, 'dd MMM yyyy')} /></td>
        </tr>
        <tr>
          <td>Allergens</td>
          <td className='bold'>{allergens && allergens.map(a => <Allergen name={a} />)}</td>
        </tr>
        <tr>
          <td>Volume / quantity</td>
          <td className='bold'>{recipe.quantity_adjusted && showQuantity(recipe.quantity_adjusted, multiplier, recipe.quantity_unit)}</td>
        </tr>
        <tr>
          <td>Production start time</td>
          <td></td>
        </tr>
        <tr>
          <td>Production end time</td>
          <td></td>
        </tr>
      </table>
      <table>
        <tr>
          <td width='40%'>Ingredient (include any reword added)</td>
          <td>Quantity used</td>
          <td width='3%'>Added&nbsp;(&#x2713;)</td>
          <td width='30%'>Batch/Lot no./date</td>
          
        </tr>

        {ingredients.map(ingredient => {

          if (ingredient.type !== 'P') return
          return (<tr>
            <td className='bold'>{recipeName(ingredient)}</td>
            <td className='bold'>{showQuantity(ingredient.quantity_adjusted, multiplier, ingredient.quantity_unit)}</td>
            <td ></td>
            <td></td>

          </tr>)
        })}

      </table>

      <table>
        <tr>
          <td width='40%'>Batch number for this production</td>
          <td style={{position:'relative'}}><b style={{fontSize:20}}>{batchNumber(selectedDate, '_', initials, recipe)}</b></td>
        </tr>
        <tr>
          <td>Batch size / Batch quantity</td>
          <td></td>
        </tr>
        <tr>
          <td>Wastage</td>
          <td></td>
        </tr>
        <tr>
          <td>'Best before' date</td>
          <td><b>{format(add(selectedDate, bbeOBJ), 'dd MMM yyyy')}</b>
            <select className='no-print monthsDropdown' value={bbe} ref={bbeRef} onChange={changeBBE}>
              <option value={'1.D'}>1 day</option>
              <option value={'2.D'}>2 days</option>
              <option value={'3.D'}>3 days</option>
              <option value={'4.D'}>4 days</option>
              <option value={'5.D'}>5 days</option>
              <option value={'6.D'}>6 days</option>
              <option value={'7.D'}>7 days</option>
              <option value={'14.D'}>14 days</option>
              <option value={'1.M'}>1 month</option>
              <option value={'2.M'}>2 months</option>
              <option value={'3.M'}>3 months</option>
              <option value={'4.M'}>4 months</option>
              <option value={'5.M'}>5 months</option>
              <option value={'6.M'}>6 months</option>
              <option value={'7.M'}>7 months</option>
              <option value={'8.M'}>8 months</option>
              <option value={'9.M'}>9 months</option>
              <option value={'10.M'}>10 months</option>
              <option value={'11.M'}>11 months</option>
              <option value={'12.M'}>12 months</option>
            </select>

            &nbsp;&nbsp;&nbsp;

            <select className='monthsDropdown' style={{fontWeight:'bold'}} ref={chilledRef} onChange={changeChilled} >
              <option>CHILLED</option>
              <option>FROZEN</option>
              <option>AMBIENT</option>
            </select>
          </td>
        </tr>

        {childRecipes.length ? <tr>
          <td className='no-line'>SUB BATCH NUMBERS</td>
          <td className='no-line'></td>
        </tr> : ''}
        
            {childRecipes?.map((child,i) => {

              const excluded = excludeSubs.includes(child.recipe.pid)

              const toggleSub = () => {
                
                if (excluded) {
                  setExcludeSubs(excludeSubs.filter(s => s !== child.recipe.pid))
                }
                else {
                  setExcludeSubs([...excludeSubs, child.recipe.pid])
                }
                

              }

              return <tr  >
                <td className={i<childRecipes.length-1 ? 'no-line' : ''}>&#9679; {recipeName(child.recipe)}</td>
                <td style={{position:'relative'}} className={i<childRecipes.length-1 ? 'no-line' : ''}><button className={excluded ? 'inv sml' : 'sml'} onClick={toggleSub}><FontAwesomeIcon icon={excluded ? faClose : faCheck} /></button> {excluded ? <b><input style={{width:60, marginLeft:0, marginRight:0}} className='editableDate' /> - <input style={{width:240, marginLeft:0, marginRight:0}} className='editableDate' /> - {cleanPID(child.recipe.pid, child.recipe.type)}</b> : <b>Included</b>}</td>
                </tr>
            })}

        <tr>
          <td>Label check (attached to this record Y/N)</td>
          <td></td>
        </tr>
        <tr>
          <td>Cooking temperature (probe checked)</td>
          <td></td>
        </tr>
        <tr>
          <td>Cooling / chilling time</td>
          <td></td>
        </tr>
        <tr>
          <td>Cooling / chilling end temperature</td>
          <td></td>
        </tr>
        <tr>
          <td>Employee name</td>
          <td><input className='editableDate' onChange={changeName} /></td>
        </tr>
        <tr>
          <td>Employee signature</td>
          <td><br /><br /><br /></td>
        </tr>
        <tr>
          <td>QA signature</td>
          <td><br /><br /><br /></td>
        </tr>
      </table>
      
      
      <BatchLabel selectedDate={selectedDate} recipe={recipe} />
    </div>
  }